import {Select, MenuItem} from "@mui/material";
import {useEffect, useState} from "react";
import {BVASelectContainer} from "./styled";

export default function BVASelect({
  items = [],
  itemLabel = "label",
  itemValue = "value",
  placeholder = "Select an item",
  value,
  width,
  onChange = () => ({})
}) {
  const [selectedItem, setSelectedItem] = useState(null)

  useEffect(() => {
    setSelectedItem(null)
  }, [])


  useEffect(() => {
      setSelectedItem(value)
  }, [value])

  const handleOnChange = (e) => {
    const item = items.find((i) => i[itemValue] === e.target.value)
    setSelectedItem(item[itemValue])

    if (e.target.value !== null) {
      onChange(item[itemValue])
    }
  }


  return (
    <BVASelectContainer width={width}>
      <Select
        onChange={handleOnChange}
        displayEmpty
        inputProps={{
          classes: {
            root: "bva-select-root"
          }
        }}
        classes={{ select: "bva-select" }}
        value={selectedItem}>
        <MenuItem disabled value={null}>
          {placeholder}
        </MenuItem>
        {items.map((item, index) => (
          <MenuItem key={index} value={item[itemValue]}>
            {item[itemLabel]}
          </MenuItem>
        ))}
      </Select>
    </BVASelectContainer>
  )
}
